// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const moment = require('moment');
const { DATE_FORMAT_API, DATE_FILTER_NONE } = require('constants/index');

// @constants
const actionTypes = require('constants/actionTypes');

const requestContractValuesFetching = contractId => ({
    type: actionTypes.BROKER_CONTRACT_VALUES_REQUEST,
    payload: {
        contractId
    }
});

const requestContractValuesFailure = (contractId) => ({
    type: actionTypes.BROKER_CONTRACT_VALUES_FAILURE,
    payload: {
        contractId
    }
});

const requestContractValuesSuccess = (data, contractId) => ({
    type: actionTypes.BROKER_CONTRACT_VALUES_SUCCESS,
    payload: {
        data,
        contractId
    }
});

const requestCryptoContractValuesFetching = portfolioId => ({
    type: actionTypes.BROKER_CRYPTO_CONTRACT_VALUES_REQUEST,
    payload: {
        portfolioId
    }
});

const requestCryptoContractValuesFailure = (portfolioId) => ({
    type: actionTypes.BROKER_CRYPTO_CONTRACT_VALUES_FAILURE,
    payload: {
        portfolioId
    }
});

const requestCryptoContractValuesSuccess = (data, portfolioId, contract, catalogueResponse) => ({
    type: actionTypes.BROKER_CRYPTO_CONTRACT_VALUES_SUCCESS,
    payload: {
        data,
        portfolioId,
        contract,
        catalogueResponse,
    }
});

const getAllContractValuesSuccess = (response, contractId) => ({
    type: actionTypes.BROKER_CONTRACT_ALL_VALUES_SUCCESS,
    payload: {
        response,
        contractId
    }
});

const getAllContractCryptoSuccess = (response, portfolioId) => ({
    type: actionTypes.BROKER_CONTRACT_ALL_CRYPTO_SUCCESS,
    payload: {
        response,
        portfolioId
    }
});

const getAllContractValuesFailure = (contractId) => {
    const responseWithNoMovements = {};
    return getAllContractValuesSuccess(responseWithNoMovements, contractId);
};

const getAllContractCryptoFailure = (portfolioId) => {
    const responseWithNoMovements = {};
    return getAllContractCryptoSuccess(responseWithNoMovements, portfolioId);
};

const getAllContractValues = (immContract) => (dispatch) => {
    const url = apiURLBuilder.getURL('brokerContratosMovimientos');

    const productNumber = immContract.get('productNumber');
    const contractNumber = immContract.get('walletNumber');
    const requestData = {
        producto: productNumber,
        numeroContrato: contractNumber,
        paginate: false
    };

    dispatch(requestContractValuesFetching(contractNumber));

    return APIGet(dispatch, url, { query: requestData }).then(
        (response) => (
            dispatch(getAllContractValuesSuccess(response, contractNumber))
        ),
        () => dispatch(getAllContractValuesFailure(contractNumber))
    );
};

const getAllCryptoContractValues = (immContract) => (dispatch) => {
    const url = apiURLBuilder.getURL('brokerCryptoMovements');
    const portfolioId = immContract.get('walletNumber');
    const contract = immContract.get('accountNumber');
    const requestData = {
        header: {
            version: 1,
        },
        query: {
            portfolioId,
            paginate: false
        }
    };

    dispatch(requestCryptoContractValuesFetching(portfolioId));

    return APIGet(dispatch, url, requestData).then(
        (response) => {

            const catalogueRequestData = {
                query: {
                    products: 'CRYPTO',
                    assetClass: 'activosDigitales',
                    subAssetClass: 'criptoactivos'
                }
            }
            APIGet(dispatch, apiURLBuilder.getURL('catalogueBrokerAdvancedSearch'), catalogueRequestData)
                .then((catalogueResponse) => {
                    dispatch(requestCryptoContractValuesSuccess(response, portfolioId, contract, catalogueResponse))
                })
                .catch(() => {
                    dispatch(getAllContractCryptoFailure(portfolioId));
                });
        }).catch(() => dispatch(getAllContractCryptoFailure(portfolioId)));
};

const getContractValues = immContract => (dispatch, getState) => {
    const immStocksContracts = getState().brokerStocksContract;
    const walletNumber = immContract.get('walletNumber');
    const immStockContract = immStocksContracts.find(
        value => {
            return value.get('walletNumber') === walletNumber;
        }
    );

    dispatch(requestContractValuesFetching(walletNumber)); //just for backward compatibility

    if (immStockContract) {
        dispatch(requestContractValuesSuccess(immStockContract, walletNumber));
    } else {
        dispatch(requestContractValuesFailure(walletNumber));
    }
}

const requestCryptoFilterFetching = (portfolioId) => ({
    type: actionTypes.BROKER_CRYPTO_CONTRACT_FILTER_REQUEST,
    payload:{ portfolioId }
});

const requestCryptoFilterSuccess = (data, portfolioId) => ({
    type: actionTypes.BROKER_CRYPTO_CONTRACT_FILTER_SUCCESS,
    payload: {
        data,
        portfolioId
    }
});

const requestCryptoFilterFailure = (portfolioId) => ({
    type: actionTypes.BROKER_CRYPTO_CONTRACT_FILTER_FAILURE,
    payload: { portfolioId }
});

const applyCryptoFilter = (immContract, immValue )  => (dispatch, getState) => {
    const valueId = immValue.get('id');
    const url = apiURLBuilder.getURL('brokerCryptoMovements');
    const portfolioId = immContract.get('walletNumber');
    const contract = immContract.get('accountNumber');
    const immFilters = getState().brokerValueMovements.getIn([valueId, 'filters']);
    const requestData = {
        header: {
            version: 1,
        },
        query: {
            portfolioId,
            paginate: false
        }
    };
    requestData.query.fromDate  = moment().startOf('day').year(2010).format(DATE_FORMAT_API);
    requestData.query.toDate = moment().startOf('day').format(DATE_FORMAT_API);

    if (immFilters && immFilters.getIn(['date', 'isActive']) && immFilters.getIn(['date', 'selected']) !== DATE_FILTER_NONE) {
        requestData.query.fromDate  = moment(immFilters.getIn(['date', 'from'])).format(DATE_FORMAT_API);
        requestData.query.toDate = moment(immFilters.getIn(['date', 'to'])).format(DATE_FORMAT_API);
    }

    dispatch(requestCryptoFilterFetching(portfolioId));

    return APIGet(dispatch, url, requestData).then(
    (response) => {
        dispatch(requestCryptoFilterSuccess(response, portfolioId));
    }).catch(() => dispatch(requestCryptoFilterFailure()));
}

const clearCryptoFilters = (walletNumber) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_CRYPTO_CONTRACT_CLEAR_FILTER,
        payload: { walletNumber }
    });
};

module.exports = {
    getAllContractValues,
    getAllCryptoContractValues,
    getContractValues,
    applyCryptoFilter,
    clearCryptoFilters
};
